export function formatViewerGateError(code: string): string {
  const map: Record<string, string> = {
    link_not_found: "This secure link is invalid, expired, or revoked.",
    not_found: "This secure link is invalid, expired, or revoked.",
    turnstile_failed: "Verification failed. Please try again.",
    email_not_authorized: "This email is not invited to this Space.",
    email_not_on_allow_list: "Your email is not on the allow list for this Space.",
    email_denied: "Access from this email domain is not permitted.",
    code_expired: "This verification link expired. Request a new one.",
    invalid_link: "This link is invalid or has been revoked.",
    expired: "This link has expired.",
    revoked: "This link has been revoked.",
    room_inactive: "This Space is not available right now. Please contact the sender.",
    email_unavailable: "We could not send the sign-in email right now. Try again in a few minutes, or contact the sender.",
    missing_session: "Your session expired. Please verify your email again.",
    session_expired: "Your session expired. Please verify your email again.",
    session_mismatch: "This session belongs to a different invite. Verify your email again.",
    fingerprint_mismatch: "This session was opened on another device. Verify your email again.",
    invalid_password: "Incorrect password. Try again.",
    rate_limited: "Too many attempts. Wait a minute and try again.",
    email_required: "Please verify your email to continue.",
    password_required: "This Space is password protected.",
    nda_required: "Please sign the non-disclosure agreement to continue.",
    nda_missing: "The NDA is not available yet. Please contact the sender.",
    signature_required: "Draw your signature to continue.",
    validation_error: "Please check your name and signature, then try again.",
  };
  if (map[code]) return map[code];
  if (code.startsWith("request_failed_")) return "Something went wrong. Please try again.";
  // Never surface raw error slugs (e.g. "link_not_found") to visitors.
  if (/^[a-z0-9_.-]+$/i.test(code) && !code.includes(" ")) {
    return "Something went wrong. Please try again.";
  }
  return code;
}
